export const apiConstants = {
  Get: 'services/app/ContactDetail/Get',
  GetAll: 'services/app/ContactDetail/GetAll',
};
